import {
  ACCOUNT_LOG_PATH,
  EDIT_ACCOUNT_PARTNER_PATH,
  EDIT_ACCOUNT_SOLITON_PATH,
  EDIT_COMPANY_ABSOLUTE_PATH,
  EDIT_NOTIFICATION_PATH,
  ENTERPRISE_LOG_PATH,
  EXPORT_LOG_PATH,
  FILE_DOWNLOAD_LOG_PATH,
  MANAGE_ACCOUNT_PARTNER_PATH,
  MANAGE_ACCOUNT_SOLITON_PATH,
  MANAGE_COMPANY_LIST_PATH,
  MANAGE_NOTIFICATION_PATH,
  MANAGE_PROJECT_REGISTRATION_PATH,
  MANAGE_SOLUTION_PATH,
  MANAGE_TRACKING_CODE_PATH,
  OPENSEARCH_RESULT,
  PREVIEW_NOTIFICATION_PATH,
  PRIVACY_POLICY_PATH,
  PROJECT_REGISTRATION_PATH,
  REGISTER_PATH,
  VISITED_LOG_PATH,
  WEBSITE_SETTING_PATH,
} from 'constant/appPath';
import {
  ERROR_CONFIRM_SIGNUP_EMAIL_PATH,
  RESET_PASSWORD_PATH,
  SIGN_IN_PATH,
  SIGN_UP_VERIFY_EMAIL_PATH,
  SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
} from 'constant/authenticationPath';

import Application from 'page/Application';
import NotFound from 'page/NotFound';

// manage account soliton
import ManageAccountSoliton, {
  AccountSolitonList,
  EditAccountSoliton,
  RegisterAccountSoliton,
} from 'page/Application/ManageAccountSoliton';

// manage account partner
import ManagerAccountPartner, {
  AccountPartnerList,
  EditAccountPartner,
  RegisterAccountPartner,
} from 'page/Application/ManagerAccountPartner';

// manage company / partner
import ManageCompanyList, {
  CompanyList,
  EditCompany,
  RegisterCompany,
} from 'page/Application/ManageCompanyList';

// manage notification
import ManageNotificationList, {
  EditNotification,
  NotificationList,
  PreviewNotification,
  RegistrationNotification,
} from 'page/Application/ManageNotificationList';

import ManageProjectRegistration, {
  EditProject,
  ProjectList,
  RegisterProject,
} from 'page/Application/ManageProjectRegistration';
import ManageSolution from 'page/Application/ManageSolution';
import WebsiteSetting from 'page/Application/WebsiteSetting';

// manage product and service
// category
import Category, {
  CategoryList,
  EditCategory,
  RegisterCategory,
} from 'page/Application/ManageProductAndService/Category';

// product
import Product, {
  EditProduct,
  ProductList,
  RegisterProduct,
} from 'page/Application/ManageProductAndService/Product';

// content
import Content, {
  ContentList,
  EditContent,
  RegisterContent,
} from 'page/Application/ManageProductAndService/Content';

import PartnerWebsite, {
  PartnerWebsiteEdit,
  PartnerWebsiteOverView,
} from 'page/Application/PartnerWebsite';

//top page product
import TopPageEditSuperDetailProduct from 'page/Application/ManageProductAndService/TopPageProduct/TopPageEditSuperDetailProduct';
import TopPageProductPartnerAdmin, {
  DetailNotifyPartnerAdmin,
  TopPageNotifyDetailPartnerAdmin,
  TopPagePartnerAdmin,
  TopPageProductDetailPartnerAdmin,
  TopPageProductSuperDetailPartnerAdmin,
} from 'page/Application/ManageProductAndService/TopPageProductPartnerAdmin';

import ProjectPreviewSolitonAdmin, {
  ProjectDetail,
  ProjectPreview,
} from 'page/Application/ProjectPreviewSolitonAdmin';

import AccountLog from 'page/Application/AccountLog';
import EnterpriseLog from 'page/Application/EnterpriseLog';
import ExportLog from 'page/Application/ExportLog';
import FileDownloadLog from 'page/Application/FileDownloadLog';
import DetailContentEditMode from 'page/Application/ManageProductAndService/TopPageProduct/DetailContentEditMode';
import TopPageEditProduct from 'page/Application/ManageProductAndService/TopPageProduct/TopPageEditProduct';
import TopPageViewSuperDetailProduct from 'page/Application/ManageProductAndService/TopPageProduct/TopPageViewProductSuperDetail';
import ManageProjectEditMode from 'page/Application/ManageProjectRegistration/ManageProjectEditMode';
import ManageTrackingCode, {
  EditTrackingCode,
  RegisterTrackingCode,
  TrackingCodeList,
} from 'page/Application/ManageTrackingCode';
import OpensearchResult from 'page/Application/Opensearch/OpensearchResult';
import PartnerWebsiteDetail from 'page/Application/PartnerWebsite/PartnerWebsiteDetail';
import PrivacyPolicy from 'page/Application/PrivacyPolicy';
import VisitedPage from 'page/Application/VisitedPage';
import Authentication from 'page/Authentication';
import ErrorConfirmSignupEmail from 'page/Authentication/ErrorConfirmSignupEmail';
import ResetPassword from 'page/Authentication/ForgotPassword/ResetPassword';
import SignIn from 'page/Authentication/SignIn';
import SignUpVerifyEmail from 'page/Authentication/SignUpVerifyEmail';
import SuccessConfirmSignupEmail from 'page/Authentication/SuccessConfirmSignupEmail';

export const solitonAdminRouterData = [
  {
    path: '/',
    element: <Application />,
    errorElement: <NotFound />,
    children: [
      // {
      //   index: true,
      //   element: <Dashboard />,
      // },
      {
        path: MANAGE_COMPANY_LIST_PATH,
        element: <ManageCompanyList />,
        children: [
          {
            index: true,
            element: <CompanyList />,
          },
          {
            path: REGISTER_PATH,
            element: <RegisterCompany />,
          },
          {
            path: EDIT_COMPANY_ABSOLUTE_PATH,
            element: <EditCompany />,
          },
        ],
      },
      {
        path: `/partner-page/:partnerId`,
        element: <PartnerWebsite />,
        children: [
          {
            index: true,
            element: <PartnerWebsiteOverView />,
          },
          {
            path: `/partner-page/:partnerId/edit`,
            element: <PartnerWebsiteEdit />,
          },
          {
            path: `/partner-page/:partnerId/detail/:noticeId`,
            element: <PartnerWebsiteDetail />,
          },
        ],
      },
      {
        path: MANAGE_ACCOUNT_SOLITON_PATH,
        element: <ManageAccountSoliton />,
        children: [
          {
            index: true,
            element: <AccountSolitonList />,
          },
          {
            path: REGISTER_PATH,
            element: <RegisterAccountSoliton />,
          },
          {
            path: EDIT_ACCOUNT_SOLITON_PATH,
            element: <EditAccountSoliton />,
          },
        ],
      },
      {
        path: MANAGE_ACCOUNT_PARTNER_PATH,
        element: <ManagerAccountPartner />,
        children: [
          {
            index: true,
            element: <AccountPartnerList />,
          },
          {
            path: REGISTER_PATH,
            element: <RegisterAccountPartner />,
          },
          {
            path: EDIT_ACCOUNT_PARTNER_PATH,
            element: <EditAccountPartner />,
          },
        ],
      },
      {
        path: MANAGE_NOTIFICATION_PATH,
        element: <ManageNotificationList />,
        children: [
          {
            index: true,
            element: <NotificationList />,
          },
          {
            path: REGISTER_PATH,
            element: <RegistrationNotification />,
          },
          {
            path: EDIT_NOTIFICATION_PATH,
            element: <EditNotification />,
          },
          {
            path: PREVIEW_NOTIFICATION_PATH,
            element: <PreviewNotification />,
          },
        ],
      },
      {
        path: 'category',
        element: <Category />,
        children: [
          {
            index: true,
            element: <CategoryList />,
          },
          {
            path: 'register',
            element: <RegisterCategory />,
          },
          {
            path: 'edit/:categoryId',
            element: <EditCategory />,
          },
        ],
      },
      {
        path: 'product',
        element: <Product />,
        children: [
          {
            index: true,
            element: <ProductList />,
          },
          {
            path: 'register',
            element: <RegisterProduct />,
          },
          {
            path: 'edit/:productId',
            element: <EditProduct />,
          },
        ],
      },
      {
        path: 'content',
        element: <Content />,
        children: [
          {
            index: true,
            element: <ContentList />,
          },
          {
            path: 'register',
            element: <RegisterContent />,
          },
          {
            path: 'edit/:contentId',
            element: <EditContent />,
          },
        ],
      },
      {
        path: 'top-page',
        element: <TopPageProductPartnerAdmin />,
        children: [
          {
            index: true,
            element: <TopPagePartnerAdmin />,
          },
          {
            path: 'edit',
            element: <DetailContentEditMode />,
          },
          {
            path: 'top-page-product/:productId/edit',
            element: <TopPageEditProduct />,
          },
          {
            path: 'top-page-product/:productId',
            element: <TopPageProductDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/list-notify/:productId',
            element: <DetailNotifyPartnerAdmin />,
          },
          {
            path: 'top-page-product/list-notify/:productId/notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/:productId/notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/:productId/top-page-detail-product/:menuId',
            element: <TopPageProductSuperDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/:productId/top-page-detail-product/:menuId/edit',
            element: <TopPageEditSuperDetailProduct />,
          },
          {
            path: 'top-page-product/:productId/top-page-detail-product/:menuId/detail/:detailId',
            element: <TopPageViewSuperDetailProduct />,
          },
          {
            path: 'list-notify',
            element: <DetailNotifyPartnerAdmin />,
          },
          {
            path: 'notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
          {
            path: 'list-notify/notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
        ],
      },
      {
        path: MANAGE_PROJECT_REGISTRATION_PATH,
        element: <ManageProjectRegistration />,
        children: [
          {
            index: true,
            element: <ProjectList />,
          },
          {
            path: 'register',
            element: <RegisterProject />,
          },
          {
            path: 'edit/:projectId',
            element: <EditProject />,
          },
          {
            path: 'editmode',
            element: <ManageProjectEditMode />,
          },
        ],
      },
      {
        path: PROJECT_REGISTRATION_PATH,
        element: <ProjectPreviewSolitonAdmin />,
        children: [
          {
            index: true,
            element: <ProjectPreview />,
          },
          {
            path: 'detail/:projectId',
            element: <ProjectDetail />,
          },
        ],
      },
      {
        path: PRIVACY_POLICY_PATH,
        element: <PrivacyPolicy />,
      },
      {
        path: MANAGE_TRACKING_CODE_PATH,
        element: <ManageTrackingCode />,
        children: [
          {
            index: true,
            element: <TrackingCodeList />,
          },
          {
            path: 'register',
            element: <RegisterTrackingCode />,
          },
          {
            path: 'edit/:codeId',
            element: <EditTrackingCode />,
          },
        ],
      },
      {
        path: FILE_DOWNLOAD_LOG_PATH,
        element: <FileDownloadLog />,
      },
      {
        path: ENTERPRISE_LOG_PATH,
        element: <EnterpriseLog />,
      },
      {
        path: ACCOUNT_LOG_PATH,
        element: <AccountLog />,
      },
      {
        path: VISITED_LOG_PATH,
        element: <VisitedPage />,
      },
      {
        path: EXPORT_LOG_PATH,
        element: <ExportLog />,
      },
      {
        path: MANAGE_SOLUTION_PATH,
        element: <ManageSolution />,
      },
      {
        path: WEBSITE_SETTING_PATH,
        element: <WebsiteSetting />,
      },
      {
        path: OPENSEARCH_RESULT,
        element: <OpensearchResult roleType={'solitonAdmin'} />,
      },
    ],
  },
  {
    path: '/',
    element: <Authentication />,
    errorElement: <NotFound />,
    children: [
      {
        path: SIGN_IN_PATH,
        element: <SignIn />,
      },
      {
        path: SIGN_UP_VERIFY_EMAIL_PATH,
        element: <SignUpVerifyEmail />,
      },
      {
        path: SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
        element: <SuccessConfirmSignupEmail />,
      },
      {
        path: ERROR_CONFIRM_SIGNUP_EMAIL_PATH,
        element: <ErrorConfirmSignupEmail />,
      },
    ],
  },
  {
    path: RESET_PASSWORD_PATH,
    element: <ResetPassword />,
  },
  {
    path: '404',
    element: <NotFound />,
  },
];
